import {
  clearCopiedImpersonationSessionStorage,
  exposeImpersonationBootstrap,
  readImpersonationBootstrap,
} from './impersonation/bootstrap';
import { createImpersonationMessageReceiver } from './impersonation/messageTransport';

const bootstrap = readImpersonationBootstrap({
  location: window.location,
  history: window.history,
});

exposeImpersonationBootstrap(bootstrap);
if (bootstrap) clearCopiedImpersonationSessionStorage();

let impersonationMessageReceiver = null;
if (bootstrap?.phase === 'loading' && bootstrap.hasLaunchId) {
  try {
    // Establish the private channel and sever window.opener before loading the
    // React/Redux cabinet chunks. The receiver promise never exposes the code
    // through the URL, storage, or the public bootstrap marker.
    impersonationMessageReceiver = createImpersonationMessageReceiver({
      kind: bootstrap.kind,
      launchId: bootstrap.launchId,
    });
    impersonationMessageReceiver.code.catch(() => {});
  } catch {
    impersonationMessageReceiver = null;
  }
}

const entryPromise = bootstrap
  ? import('./impersonation/entry')
  : import('./normalEntry');

entryPromise
  .then(({ mountApp }) => mountApp({ bootstrap, impersonationMessageReceiver }))
  .catch(() => {
    const root = document.getElementById('root');
    if (!root) return;

    root.textContent = bootstrap
      ? 'Не удалось загрузить служебный кабинет. Закройте окно и откройте кабинет заново.'
      : 'Не удалось загрузить приложение. Обновите страницу.';
  });
